import { includes } from "lodash";
import ButtonView from "views/button_view";
/* eslint-disable
    consistent-return,
    func-names,
    no-multi-assign,
    no-shadow,
    no-undef,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let IndicatorButtonView;

// Represents a button with an indicator light.
export default IndicatorButtonView = (function () {
  IndicatorButtonView = class IndicatorButtonView extends ButtonView {
    static initClass() {
      this.GREEN = "green";
      this.ORANGE = "orange";
      this.RED = "red";
      this.GREY = "grey";

      this.prototype.className = "button indicator";
      this.prototype.colors = [this.GREEN, this.ORANGE, this.RED, this.GREY];
    }

    setColor(value) {
      this.$el.removeClass(this.colors.join(" "));

      if (value != null) {
        if (!includes(this.colors, value)) { throw new Error(`unknown color '${value}'`); }
        return this.$el.addClass(value);
      }
    }
  };
  IndicatorButtonView.initClass();
  return IndicatorButtonView;
}());
